import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useForm, Controller, ErrorMessage } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { updateCustomProducts, removeUnlistedProdsByIndex } from 'redux/voiceOrders';

import Form, { FormControl } from './productForm.style';
import {
  getOrderDetails,
  editProduct,
  addProduct,
  pushVpcItems,
  pushVpcItemsIds,
  pushNewVpcItemsIds,
} from 'redux/voiceOrderDetails';

const productSchema = yup.object().shape({
  product_name: yup.string().required('Required'),
  quantity: yup.number('Should be number').required('Required'),
  price: yup.number('Should be number').required('Required'),
  source_price: yup.number('Should be number').required('Required'),
  description: yup.string().required('Required'),
  assigned_pickup_source: yup.string().required('Required')
});

const ProductForm = ({ handleAddProduct, handleClose }) => {
  const dispatch = useDispatch();
  const voiceOrderId = useSelector((state) => state?.voiceOrderDetails?.data?.id);
  const authToken = useSelector((state) => state.auth.token);
  const { control, handleSubmit, errors } = useForm({
    validationSchema: productSchema,
    defaultValues: {
      product_name: '',
      quantity: '',
      price: '',
      source_price: '',
      description: '',
      assigned_pickup_source: ''
    }
  });
  const onSubmit = (data) => {
    const body = {
      product: {
        ...data
      }
    };
    dispatch(pushVpcItems(body));
    dispatch(pushVpcItemsIds(1));
    dispatch(pushNewVpcItemsIds(1));
    handleAddProduct(body);
    // console.log(voiceOrderId, authToken)
    dispatch(
      updateCustomProducts(
        voiceOrderId,
        body?.product,
        authToken
      )
    );
    handleClose();
  };
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <FormControl>
          <label htmlFor="product_name">Item Name</label>
          <Controller
            as={TextField}
            fullWidth
            id="product_name"
            name="product_name"
            control={control}
            variant="outlined"
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage style={{ color: 'red' }} errors={errors} name="product_name" />
          </span>
        </FormControl>
        <FormControl>
          <label htmlFor="quantity">Quantity</label>
          <Controller
            as={TextField}
            fullWidth
            type="number"
            id="quantity"
            name="quantity"
            control={control}
            variant="outlined"
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage errors={errors} name="quantity" />
          </span>
        </FormControl>

        <FormControl>
          <label htmlFor="price">Price</label>
          <Controller
            as={TextField}
            id="price"
            type="number"
            variant="outlined"
            name="price"
            control={control}
            fullWidth
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage errors={errors} name="price" />
          </span>
        </FormControl>

        <FormControl>
          <label htmlFor="source_price">Source Price</label>
          <Controller
            as={TextField}
            fullWidth
            type="number"
            id="source_price"
            name="source_price"
            control={control}
            variant="outlined"
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage errors={errors} name="source_price" />
          </span>
        </FormControl>
      </div>
      <div>
        <FormControl>
          <label htmlFor="description">Description</label>
          <Controller
            as={TextField}
            multiline
            fullWidth
            id="description"
            name="description"
            control={control}
            variant="outlined"
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage errors={errors} name="description" />
          </span>
        </FormControl>
        <FormControl>
          <label htmlFor="assigned_pickup_source">Assigned Pickup Source</label>
          <Controller
            as={TextField}
            fullWidth
            multiline
            id="assigned_pickup_source"
            name="assigned_pickup_source"
            control={control}
            variant="outlined"
          />
          <span style={{ color: 'red' }}>
            <ErrorMessage errors={errors} name="assigned_pickup_source" />
          </span>
        </FormControl>
        <div style={{ textAlign: 'right' }}>
          <Button type="submit" variant="contained" color="primary">
            Add Product
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default ProductForm;
